import { actionTypes } from '../actions/top.action';
const initialState = {
    top: [],
    title: null,
    user: {},
    error: {},
    success: false
}

const TopReducer = (state = initialState, { type, payload }) => {
    switch (type) {

    case actionTypes.INDEX:
        return { ...state, ...payload }

    case actionTypes.CLEAR:
        return {
            top: [],
            title: null,
            error: {},
            success: false
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    default:
        return state
    }
}

export default TopReducer